import React from "react";
import { SectionContainer } from "../SectionContainer";

export const Home = ({data, openMedia}) => {

    return (
        <main className="main-container" aria-label="Zone de contenu principal">
            <div className="content">
                <div className="subcontent">
                    <div className="submenu-container">
                        <h1>Risques majeurs à Niort</h1>
                    </div>
                    <SectionContainer selectedItem={data} openMedia={openMedia}/>
                </div>
            </div>
        </main>
    )
}